
const FieldConfig = {

    'Product Reviews': [
        { name: 'ProductName', placeholder: 'Product Name', type: 'text' },
        { name: 'ProductRating', placeholder: 'Product Rating', type: 'text' },
        { name: 'ProductReview', placeholder: 'Product Review', type: 'text' },
        { name: 'SubmissionDate', placeholder: 'Submission Date', type: 'date' },
    ],
    'Followed Stores': [
        { name: 'ProductID', placeholder: 'Product ID', type: 'text' },
        { name: 'AddedDate', placeholder: 'Added Date', type: 'date' },
        { name: 'paymentAmount', placeholder: 'Payment Amount', type: 'text' },
    ],
    'Followed Stores': [
        { name: 'store', placeholder: 'Store', type: 'text' },
    ],
    'Interaction History': [
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'interactionDate', placeholder: 'Interaction Date', type: 'date' },
        { name: 'type', placeholder: 'Type', type: 'text' },
    ],
    'Order History': [
        { name: 'orderNumber', placeholder: 'Order #', type: 'text' },
        { name: 'purchaseDate', placeholder: 'Purchasing Date', type: 'date' },
        { name: 'paymentAmount', placeholder: 'Payment Amount', type: 'text' },
    ],
    'Return History': [
        { name: 'returnNumber', placeholder: 'Return #', type: 'text' },
        { name: 'returnDate', placeholder: 'Return Date', type: 'date' },
        { name: 'refundAmount', placeholder: 'Refund Amount', type: 'text' },
    ],
    'All Coupons': [
        { name: 'couponCode', placeholder: 'Coupon Code', type: 'text' },
        { name: 'discountType', placeholder: 'Discount Type', type: 'text' },
        { name: 'discount', placeholder: 'Discount', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'Active Coupons': [
        { name: 'couponCode', placeholder: 'Coupon Code', type: 'text' },
        { name: 'discountType', placeholder: 'Discount Type', type: 'text' },
        { name: 'discount', placeholder: 'Discount', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'Deactivated Coupons': [
        { name: 'couponCode', placeholder: 'Coupon Code', type: 'text' },
        { name: 'discountType', placeholder: 'Discount Type', type: 'text' },
        { name: 'discount', placeholder: 'Discount', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'All Vouchers': [
        { name: 'voucherCode', placeholder: 'Voucher Code', type: 'text' },
        { name: 'voucherType', placeholder: 'Voucher Type', type: 'text' },
        { name: 'monetaryValue', placeholder: 'Monetary Value', type: 'text' },
        { name: 'remainingValue', placeholder: 'Remaining Value', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'Active Vouchers': [
        { name: 'voucherCode', placeholder: 'Voucher Code', type: 'text' },
        { name: 'voucherType', placeholder: 'Voucher Type', type: 'text' },
        { name: 'monetaryValue', placeholder: 'Monetary Value', type: 'text' },
        { name: 'remainingValue', placeholder: 'Remaining Value', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'Deactivated Vouchers': [
        { name: 'voucherCode', placeholder: 'Voucher Code', type: 'text' },
        { name: 'voucherType', placeholder: 'Voucher Type', type: 'text' },
        { name: 'monetaryValue', placeholder: 'Monetary Value', type: 'text' },
        { name: 'remainingValue', placeholder: 'Remaining Value', type: 'text' },
        { name: 'validityPeriod', placeholder: 'Validity Period', type: 'text' },
        { name: 'appliedTo', placeholder: 'Applied To', type: 'text' },
    ],
    'All Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Active Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Under Approval Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Inactive Out of Stock Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Inactive Restricted Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Inactive Deleted Products': [
        { name: 'productName', placeholder: 'Product Name', type: 'text' },
        { name: 'sku', placeholder: 'Product SKU', type: 'text' },
        { name: 'dateCreated', placeholder: 'Date created', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'All Orders': [
        { name: 'productName', placeholder: 'Order ID/Product', type: 'text' },
        { name: 'orderDate', placeholder: 'Order date', type: 'text' },
        { name: 'totalPayment', placeholder: 'Total Payment', type: 'number' },
        { name: 'paymentMethod', placeholder: 'Payment method', type: 'text' },
        { name: 'paymentStatus', placeholder: 'Payment status', type: 'text' },
    ],
    "Pending Orders": [
        { name: "orderId", placeholder: 'Order Id', type: 'text' },
        { name: "orderDate", placeholder: 'Order date', type: 'date' },
        { name: "price", placeholder: 'Price', type: 'text' },
        { name: "paymentMethod", placeholder: 'Payment method', type: 'text' },
    ],
    "Orders Returns and Refunds": [
        { name: 'returnId', placeholder: "Return Id", type: 'text' },
        { name: 'orderNo', placeholder: "Order #", type: 'text' },
        { name: 'customerName', placeholder: "Customer Name", type: 'text' },
        { name: 'status', placeholder: "Status", type: 'text' },
    ],
    'Existing Gift Wrapping Options': [
        { name: 'name', placeholder: 'Name', type: "text" },
        { name: 'price', placeholder: 'Price', type: "number" },
    ],
    'Customer Engage Product Reviews': [
        { name: 'reviewId', placeholder: 'Review ID', type: "text" },
        { name: 'product', placeholder: 'Product', type: "text" },
        { name: 'customerName', placeholder: 'Customer name', type: "text" },
        { name: 'rating', placeholder: 'Rating', type: "number" },
    ],
    'Customer Engage Seller Reviews': [
        { name: 'reviewId', placeholder: 'Review ID', type: "text" },
        { name: 'satisfactionLevel', placeholder: 'Satisfaction level', type: "text" },
        { name: 'customerName', placeholder: 'Customer name', type: "text" },
        { name: 'rating', placeholder: 'Rating', type: "number" },
    ],
    "Purchase History": [
        { name: 'customerId', placeholder: 'Customer ID', type: "text" },
        { name: 'customerName', placeholder: 'Customer name', type: "text" },
        { name: 'totalPurchases', placeholder: 'Total Purchases', type: "number" },
        { name: 'lastPurchase', placeholder: 'Last Purchase', type: "text" },
    ],
    "Campaign Product Selection": [
        { name: 'productName', placeholder: 'Product Name', type: "text" },
        { name: 'productSKU', placeholder: 'Product SKU', type: "text" },
        { name: 'category', placeholder: 'Category', type: "text" },
        { name: 'price', placeholder: 'Price', type: "number" },
        { name: 'status', placeholder: 'Status', type: "text" },

    ],
    "Coupons All": [
        { name: 'couponCode', placeholder: 'Coupon Code', type: "text" },
        { name: 'couponType', placeholder: 'Coupon Type', type: "text" },
        { name: 'validityPeriod', placeholder: 'Validity period', type: "text" },
        { name: 'discount', placeholder: 'Discount', type: "text" },
        { name: 'status', placeholder: 'Status', type: "text" },
    ],
    'Vouchers All': [
        { name: 'voucherName', placeholder: "Voucher name", type: 'text' },
        { name: 'voucherCode', placeholder: "Voucher Code", type: 'text' },
        { name: 'validityPeriod', placeholder: "Validity Period", type: 'text' },
        { name: 'value', placeholder: "Value", type: 'text' },
    ],
    "Free Delivery": [
        { name: 'period', placeholder: "Period", type: 'text' },
        { name: 'region', placeholder: "Region", type: 'text' },
        { name: 'applicability', placeholder: "Applicability", type: 'text' },
        { name: 'status', placeholder: "Status", type: 'text' },
    ],
    'Advertisement Management': [
        { name: "orderId", placeholder: "Order ID", type: 'text' },
        { name: "orderDate", placeholder: "Order Date", type: 'date' },
        { name: "price", placeholder: "Price", type: 'text' },
        { name: "status", placeholder: "Status", type: 'text' },
    ],

    "Pricing and Finance Transaction History": [
        { name: "productName", placeholder: "Product name", type: 'text' },
        { name: "productSKU", placeholder: "Product SKU", type: 'date' },
        { name: "dateCreated", placeholder: "Date created", type: 'text' },
        { name: "status", placeholder: "Status", type: 'text' },
    ],
    "Pricing and Finance Payment Info": [
        { name: "productName", placeholder: "Product name", type: 'text' },
        { name: "productSKU", placeholder: "Product SKU", type: 'date' },
        { name: "dateCreated", placeholder: "Date created", type: 'text' },
        { name: "status", placeholder: "Status", type: 'text' },
    ],
    'Manage Platform Products': [
        { name: 'productName', placeholder: 'Product name', type: 'text' },
        { name: 'productId', placeholder: 'Product ID', type: 'text' },
        { name: 'sku', placeholder: 'Seller SKU', type: 'text' },
        { name: 'inboundStatus', placeholder: 'Inbound Status', type: 'text' },
        { name: 'productStatus', placeholder: 'Product Status', type: 'text' },
    ],
    'Manage Fulfillment SKU': [
        { name: 'fulfillmentSKU', placeholder: 'Fulfillment SKU', type: 'text' },
        { name: 'sellerSKU', placeholder: 'Seller SKU', type: 'text' },
        { name: 'platformSKU', placeholder: 'Platform SKU', type: 'text' },
        { name: 'barcode', placeholder: 'Barcode', type: 'text' },
        { name: 'serialNo', placeholder: 'Serial no.', type: 'text' },
    ],
    'Order Management': [
        { name: 'orderId', placeholder: 'Order ID', type: 'text' },
        { name: 'customerName', placeholder: 'Customer name', type: 'text' },
        { name: 'orderDate', placeholder: 'Order date', type: 'text' },
        { name: 'totalAmount', placeholder: 'Total Amount', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Track Shipments': [
        { name: 'shipmentID', placeholder: 'Shipment ID', type: 'text' },
        { name: 'trackingID', placeholder: 'Tracking ID', type: 'text' },
        { name: 'shipmentdate', placeholder: 'Shipment date', type: 'text' },
        { name: 'warehouse', placeholder: 'Warehouse', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Received Inventory': [
        { name: 'shipmentID', placeholder: 'Shipment ID', type: 'text' },
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'skuID', placeholder: 'SKU ID', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Inventory Discrepancies': [
        { name: 'discrepancyID', placeholder: 'Discrepancy ID', type: 'text' },
        { name: 'shipmentID', placeholder: 'Shipment ID', type: 'text' },
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'skuID', placeholder: 'SKU ID', type: 'text' },
    ],
    'Track Shipments Back': [
        { name: 'returnShipmentID', placeholder: 'Return Shipment ID', type: 'text' },
        { name: 'trackingID', placeholder: 'Tracking ID', type: 'text' },
        { name: 'returndate', placeholder: 'Return date', type: 'text' },
        { name: 'warehouse', placeholder: 'Warehouse', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Inventory Report': [
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'inventoryvalue', placeholder: 'Inventory Value', type: 'text' },
        { name: 'location', placeholder: 'Location', type: 'text' },
        { name: 'expirydate', placeholder: 'Expiry Date', type: 'text' },
    ],
    'Expiry Date Report': [
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'expirydate', placeholder: 'Expiry Date', type: 'text' },
        { name: 'stocklevel', placeholder: 'Current Stock Level', type: 'text' },
        { name: 'location', placeholder: 'Location', type: 'text' },
    ],
    'Inventory Aging Report': [
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'below30days', placeholder: '0-30 Days', type: 'text' },
        { name: 'above30to60days', placeholder: '31-60 Days', type: 'text' },
        { name: 'totalvalue', placeholder: 'Total Value', type: 'text' },
    ],
    'Inventory Reconciliation Report': [
        { name: 'productID', placeholder: 'Product ID', type: 'text' },
        { name: 'productname', placeholder: 'Product name', type: 'text' },
        { name: 'physicalcount', placeholder: 'Physical Count', type: 'text' },
        { name: 'recordedcount', placeholder: 'Recorded Count', type: 'text' },
        { name: 'valueperunit', placeholder: 'Value per Unit', type: 'text' },
    ],
    'Sales Report': [
        { name: 'orderID', placeholder: 'Order ID', type: 'text' },
        { name: 'customername', placeholder: 'Customer name', type: 'text' },
        { name: 'orderdate', placeholder: 'Order date', type: 'text' },
        { name: 'lastupdate', placeholder: 'Last Update', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    'Dropoffs': [
        { name: 'date', placeholder: 'Date', type: 'date' },
        { name: 'time', placeholder: 'Time', type: 'text' },
        { name: 'warehouse', placeholder: 'Warehouse', type: 'text' },
    ],
    'Packaging Material Order': [
        { name: 'OrderID', placeholder: 'Order ID', type: 'number' },
        { name: 'orderDate', placeholder: 'Order Date', type: 'date' },
        { name: 'price', placeholder: 'Price', type: 'number' },
        { name: 'paymentMethod', placeholder: 'Payment Method', type: 'text' },
    ],
    'Maelano Wallet Activity': [
        { name: "date", placeholder: 'Date', type: 'text' },
        { name: "transactionType", placeholder: 'Transaction type', type: 'text' },
        { name: "amount", placeholder: 'Amount', type: 'text' },
        { name: "status", placeholder: 'Status', type: 'text' },
    ],
    'CRM Customer List': [
        { name: "customerId", placeholder: 'Customer ID', type: 'number' },
        { name: "customerName", placeholder: 'Customer Name', type: 'text' },
        { name: "joined", placeholder: 'Joined', type: 'text' },
    ],
    'CRM Communication Log': [
        { name: "date", placeholder: 'Date', type: 'text' },
        { name: "customerName", placeholder: 'Customer Name', type: 'text' },
        { name: "communicationType", placeholder: 'Communication Type', type: 'text' },
    ],
    "Vip Customers List": [
        { name: "customerId", placeholder: 'Customer ID', type: "text" },
        { name: "customerName", placeholder: 'Customer Name', type: "text" },
        { name: "joined", placeholder: 'Joined', type: "text" },
        { name: "lastPurchased", placeholder: 'Last Purchase', type: "text" },
    ],
    'Existing Category': [
        { name: 'parentcategory', placeholder: 'Parent category', type: 'text' },
        { name: 'subcategory', placeholder: 'Sub-category', type: 'text' },
        { name: 'totalproducts', placeholder: 'Total products', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],

    "Brand Management Product Overview": [
        { name: 'category', placeholder: 'Category', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
        { name: 'product', placeholder: 'Product', type: 'text' },
        { name: 'seller', placeholder: 'Seller', type: 'text' },
    ]
};

export default FieldConfig;
